import React, { ReactElement } from 'react'

/**
 * Adds tradmark superscript to strings based on a keyword
 *
 * Logic
 * 1. Find index of tradeMarkedWord
 * 2. Split fullString based on index + length of tradeMarkedWord
 * 3. Return formatted string with Trademark
 */
export function addTradeMark(
  fullString: string,
  tradeMarkedWord: string,
): ReactElement {
  if (!fullString.includes(tradeMarkedWord)) return <>{fullString}</>
  const index = fullString.indexOf(tradeMarkedWord)
  const beginning = fullString.slice(0, index + tradeMarkedWord.length)
  const ending = fullString.slice(index + tradeMarkedWord.length)

  return (
    <>
      {beginning}
      <sup>®</sup>
      {ending}
    </>
  )
}
